import * as React from 'react';
import warning from 'warning';
import Base, { BlockProps } from 'antd/lib/typography/Base';
import { tupleNum, Omit } from 'antd/lib/_util/type';
import { Typography as ATypography } from 'antd';
import {FunctionComponent} from 'react';
import classNames from 'classnames';
import './style';

const TITLE_ELE_LIST = tupleNum(1, 2, 3, 4,5);

type TitleProps = Omit<BlockProps & { level?: (typeof TITLE_ELE_LIST)[number] }, 'strong'>;


export const Title: FunctionComponent<TitleProps> = props => {
    const { level = 1, ...restProps } = props;
    let component: string;
  
    if (TITLE_ELE_LIST.indexOf(level) !== -1) {
        component = `h${level}`;
    } else {
        warning(false, 'Title only accept `1 | 2 | 3 | 4` as `level` value.');
        component = 'h1';
    }
  
    const cls = `gc-typography-${props.type}`
  
  
  
    return <Base {...restProps} component={component} className={classNames(`gc-typography-h${level}`,cls)} />;
};

const Typography = {
    Text: ATypography.Text,
    Title: Title,
    Paragraph: ATypography.Paragraph
}

export default Typography;
